import React from "react";
import { Navigate } from "react-router-dom";
import DoctorBiopsyView from "../doctor/DoctorBiopsyView";
import LabBiopsyEdit from "../lab/LabBiopsyEdit";
import PathologistBiopsyView from "../pathologist/PathologistBiopsyView";
import AdminBiopsyView from "../admin/AdminBiopsyView";
import TeachingAdminBiopsyView from "../teaching-admin/TeachingAdminBiopsyView";

export default function BiopsyViewDispatcher() {
  const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();
  if (userType === "doctor")         return <DoctorBiopsyView />;
  if (userType === "lab technician") return <LabBiopsyEdit />;
  if (userType === "pathologist")    return <PathologistBiopsyView />;
  if (userType === "admin")          return <AdminBiopsyView />;
  if (userType === "teaching admin") return <TeachingAdminBiopsyView />;
  return <Navigate to="/" replace />;
}
